export interface IBreadcrumb {
  id: string;
  path: string;
  label: string;
}

export const addChangeBreadcrumbsEventListener = (callback: (newBreadcrumbs: IBreadcrumb[]) => void): (() => void) => {
  const handleEvent = (e: CustomEvent<IBreadcrumb[]>) => {
    callback(e.detail);
  }

  addEventListener(`CHANGE_BREADCRUMBS_EVENT`, handleEvent);

  return () => removeEventListener(`CHANGE_BREADCRUMBS_EVENT`, handleEvent);
}

export const changeBreadcrumbs = (breadcrumbs: IBreadcrumb[]) => {
  dispatchEvent(new CustomEvent('CHANGE_BREADCRUMBS_EVENT', {
    detail: breadcrumbs
  }));
};